import general from './general';
import noMatch from './noMatch';
import legal from './legal';
import subscription from './subscription';

// --------------DESKTOP-USERS--------------
const routes = [
  ...general,
  ...legal,
  ...subscription,
  /* add new routes here */
];
// !! Always keep "noMatch" at the end !!
routes.push(...noMatch);

export { routes };
export default routes;
